import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap-5';
import map from 'lodash/map';
import humanizeString from 'humanize-string';
import titleize from 'titleize';

import SelectableRecordsTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';

export default class EnumFieldMapper extends React.Component {
  static propTypes = {
    buildoutField: PropTypes.string.isRequired,
    buildoutFieldLabel: PropTypes.string.isRequired,
    enumMapping: PropTypes.object.isRequired,
    enumValues: PropTypes.object.isRequired,
    onUpdateEnumMapping: PropTypes.func.isRequired
  }

  handleUpdateEnumMapping = (e, buildoutField, importedValue) => {
    const { value } = e.target;

    this.props.onUpdateEnumMapping(
      buildoutField,
      importedValue,
      value.length > 0 ? value : null
    );
  }

  enumMappingColumnHeaders = (
    <>
      <th>Buildout Value</th>
      <th>Imported Value</th>
    </>
  )

  render() {
    const { enumMapping, buildoutFieldLabel } = this.props;

    return (
      <Col md={6} sm={12}>
        <p className="fs-large mt-0 text-center">
          Please specify the mapping for <strong className="fw-semibold">{buildoutFieldLabel}</strong>
        </p>
        <div className="table-container mb-5">
          <SelectableRecordsTable
            className="field-mapping-table"
            columnHeaders={this.enumMappingColumnHeaders}
            hasSelectAll={false}
            hasSelectColumn={false}
            name="enumMappingTable"
          >
            {map(enumMapping, (buildoutValue, importedValue) => (
              this.renderEnumMappingRow(buildoutValue, importedValue)
            ))}
          </SelectableRecordsTable>
        </div>
      </Col>
    );
  }

  renderEnumMappingRow(buildoutValue, importedValue) {
    const { buildoutField, enumValues } = this.props;

    return (
      <SelectableRow hideCheckbox key={importedValue}>
        <td>
          <Form.Select
            className={buildoutValue == null ? 'bg-warning' : ''}
            name="buildoutValueSelect"
            value={buildoutValue || ''}
            onChange={e => this.handleUpdateEnumMapping(e, buildoutField, importedValue)}
          >
            <option key="blank" value="">Select a field</option>
            {map(enumValues, (value, label) => (
              <option key={label} value={value}>
                {titleize(humanizeString(label))}
              </option>
            ))}
          </Form.Select>
        </td>
        <td name="importedValue">{importedValue}</td>
      </SelectableRow>
    );
  }
}
